import Token from '@sheinx/theme';

export default {
  // margin: 'auto',
  boxSizing: 'border-box',
  position: 'relative',
  borderStyle: 'solid',
  borderColor: `transparent ${Token.spinColor} ${Token.spinColor} ${Token.spinColor}`,
  borderRadius: '50%',
  animation: '$ring 1s linear infinite',
};

